import type { DocKind } from "@shared/types";

export const DOC_KINDS: { value: DocKind; label: string }[] = [
  { value: "doc", label: "Doc" },
  { value: "meeting", label: "Meeting notes" },
  { value: "decision", label: "Decision" },
  { value: "adr", label: "ADR" },
  { value: "note", label: "Note" },
];

export function kindLabel(kind: DocKind): string {
  return DOC_KINDS.find((k) => k.value === kind)?.label ?? kind;
}

/** Extract unchecked Markdown action items (`- [ ] text`) from a note body. */
export function parseActionItems(body: string): string[] {
  const out: string[] = [];
  for (const line of body.split("\n")) {
    const m = line.match(/^\s*[-*]\s*\[ \]\s+(.+?)\s*$/);
    if (m && m[1]) out.push(m[1]);
  }
  return out;
}

/** Starter Markdown body for a new document of the given kind. */
export function docTemplate(kind: DocKind): string {
  const today = new Date().toISOString().slice(0, 10);
  switch (kind) {
    case "meeting":
      return `# Meeting — ${today}\n\n**Attendees:** \n**Date:** ${today}\n\n## Agenda\n- \n\n## Notes\n\n## Decisions\n- \n\n## Action items\n- [ ] \n`;
    case "decision":
      return `# Decision\n\n**Status:** proposed\n**Owner:** \n**Date:** ${today}\n\n## Context\n\n## Options considered\n1. \n2. \n\n## Decision\n\n## Rationale\n`;
    case "adr":
      return `# ADR: <title>\n\n**Status:** Proposed\n**Date:** ${today}\n\n## Context\n\nWhat is the issue motivating this decision?\n\n## Decision\n\nWhat are we doing, and why?\n\n## Consequences\n\nWhat becomes easier or harder as a result?\n`;
    case "note":
      return `# Note\n\n`;
    default:
      return `# Overview\n\n## Section\n\n`;
  }
}
